const handleSetCurrent = (state, action) => {
  return { current: action.payload, archived: state.archived };
};

const handleSetArhived = (state, action) => {
  return { current: state.current, archived: action.payload };
};

const handleToggleTodo = (state, action) => {
  let newState = { ...state };
  const todo = newState.current.find((todo) => todo.id === action.payload.id);
  todo.completed = !todo.completed;
  return newState;
};

const handleRefreshTodos = (state) => {
  let newState = { ...state };
  newState.current.sort((a, b) => ("" + a.endDate).localeCompare(b.endDate)); // sort by date
  newState.current.sort((a, b) => {
    if (a.completed === false && b.completed === true) {
      return -1;
    }
    if (a.completed === true && b.completed === false) {
      return 1;
    }
    return 0;
  }); // sort by completed

  return newState;
};

const handleToggleEditTodo = (state, action) => {
  let newState = { ...state };
  const todo = newState.current.find((todo) => todo.id === action.payload.id);
  todo.editMode = !todo.editMode;
  return newState;
};

const handleAddTodo = (state, action) => {
  let newState = { ...state };
  newState = {
    current: [action.payload.newTodo, ...newState.current],
    archived: newState.archived,
  };
  return newState;
};

const handleModifyTodo = (state, action) => {
  let newState = { ...state };
  let newTodos = newState.current.filter(
    (todoObj) => todoObj.id !== action.payload.id
  );
  let todoToModify = newState.current.find(
    (todoObj) => todoObj.id === action.payload.id
  );
  let todoToModifyIdx = newState.current.findIndex(
    (todoObj) => todoObj.id === action.payload.id
  );
  let modifiedTodo = {
    ...todoToModify,
    ...action.payload.newPropsObj,
  };
  newTodos.splice(todoToModifyIdx, 0, modifiedTodo);
  newState.current = newTodos;
  return newState;
};

const handleArchiveCompleted = (state) => {
  if (state.current.length < 1) return state;
  let newState = { ...state };
  const newArchirvedTodos = newState.current
    .filter((todo) => {
      return todo.completed;
    })
    .map((todo) => {
      return { ...todo, ...{ viewState: false }, ...{ editMode: false } };
    });
  const newTodos = newState.current.filter((todo) => {
    return !todo.completed;
  });
  newState.archived = [...newArchirvedTodos, ...newState.archived];
  newState.current = newTodos;
  return newState;
};

const handleToggleAllCompleted = (state) => {
  if (state.current.length < 1) return state;
  let newTodos;
  let newState = { ...state };
  if (newState.current[0].completed === true) {
    newTodos = newState.current.map((todo) => {
      todo.completed = false;
      return todo;
    });
  } else {
    newTodos = newState.current.map((todo) => {
      todo.completed = true;
      return todo;
    });
  }
  newState.current = newTodos;
  return newState;
};

const handleDeleteArhcivedTodos = (state) => {
  if (state.archived.length < 1) return state;
  let newState = { ...state };
  newState.archived = [];
  return newState;
};

export const todosReducer = (state = { current: [], archived: [] }, action) => {
  switch (action.type) {
    case "SET_CURRENT":
      return handleSetCurrent(state, action);
    case "SET_ARCHIVED":
      return handleSetArhived(state, action);
    case "TOGGLE_TODO":
      return handleToggleTodo(state, action);
    case "REFRESH_TODOS":
      return handleRefreshTodos(state);
    case "TOGGLE_EDIT_TODO":
      return handleToggleEditTodo(state, action);
    case "ADD_TODO":
      return handleAddTodo(state, action);
    case "MODIFY_TODO":
      return handleModifyTodo(state, action);
    case "ARCHIVE_COMPLETED":
      return handleArchiveCompleted(state);
    case "TOGGLE_ALL_COMPLETED":
      return handleToggleAllCompleted(state);
    case "DELETE_ARCHIVED_TODOS":
      return handleDeleteArhcivedTodos(state);
    default:
      return state;
  }
};
